import { articles, packages, weightType } from "../config/statusConfig";

export const getPackageStatus = (status: string) => {
  switch (status) {
    case packages.empty:
      return (
        <span className="badge badge-pill badge-secondary">Completandose</span>
      );
    case packages.completing:
      return (
        <span className="badge badge-pill badge-secondary">Completandose</span>
      );

    case packages.onTheWay:
      return <span className="badge badge-pill badge-dark">En camino</span>;

    case packages.inWarehouse:
      return <span className="badge badge-pill badge-primary">En bodega</span>;

    case packages.completed:
      return <span className="badge badge-pill badge-info">Completado</span>;

    case packages.finalized:
      return <span className="badge badge-pill badge-success">Finalizado</span>;

    default:
      return <span className="badge badge-pill badge-secondary">NA</span>;
  }
};

export const getArticleStatus = (status: string) => {
  switch (status) {
    case articles.waiting:
      return (
        <span className="badge badge-pill badge-secondary">Esperando</span>
      );

    case articles.disactive:
      return <span className="badge badge-pill badge-dark">Desactivado</span>;

    case articles.received:
      return <span className="badge badge-pill badge-info">Recibido</span>;
    default:
      return <span className="badge badge-pill badge-secondary">NA</span>;
  }
};

export const getWeightType = (type: string) => {
  switch (type) {
    case weightType.volume:
      return <span>V</span>;
    case weightType.weight:
      return <span>LBS</span>;
    default:
      return <span>LBS</span>;
  }
};

export const getWeightOptions = () => {
  return [
    {
      value: weightType.weight,
      label: "Peso",
    },
    {
      value: weightType.volume,
      label: "Volumen",
    },
  ];
};

export const getArticleStatusOptions = () => {
  return [
    {
      value: articles.disactive,
      label: "Inactivo",
    },
    {
      value: articles.waiting,
      label: "Esperando",
    },
    {
      value: articles.received,
      label: "Recibido",
    },
  ];
};
